import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import BannerImage from "../../assets/images/hero.png";
import Container from "../shared/Container";

const HomeHeroSection: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation("home");

  const text = t("choose_the_best_assets");
  const [firstPart, secondPart] = text.split("$10.000");

  return (
    <>
      <Container
        sx={{
          position: "relative",
          py: { xs: 4, md: 6 },
        }}
      >
        <Grid container spacing={4} sx={{ py: { xs: 4, md: 12 } }}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "start" },
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  py: 0.5,
                  pl: 0.5,
                  pr: 2,
                  width: "fit-content",
                  borderRadius: 100,
                  backgroundColor: "#00DB9714",
                }}
              >
                <Box
                  sx={{
                    display: isMobile ? "none" : "grid",
                    placeItems: "center",
                    width: { xs: 24, md: 32 },
                    height: { xs: 24, md: 32 },
                    borderRadius: "50%",
                    backgroundColor: "#00000029",
                  }}
                >
                  <PeopleAltOutlinedIcon
                    sx={{ color: "#00DB97", fontSize: { xs: 12, md: 16 } }}
                  />
                </Box>
                <Typography color="#00DB97" fontSize={{ xs: "0.7rem", md: 14 }}>
                  {t("the_largest_trading")}
                </Typography>
              </Stack>
            </Box>
            <Stack spacing={2} sx={{ mt: 3, mb: { xs: 3, md: 5 } }}>
              <Typography
                fontFamily="Epilogue"
                align={isMobile ? "center" : "left"}
                fontSize={{
                  xs: 40,
                  md: 56,
                }}
                fontWeight={700}
                lineHeight={1.15}
              >
                {t("start_your_trading")}
              </Typography>
              <Typography fontSize={16} align={isMobile ? "center" : "left"}>
                {firstPart}$10.000
                {isMobile && <br />}
                {secondPart}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent={{ xs: "center", md: "start" }}
            >
              <Button
                component={RouterLink}
                to="/register"
                variant="contained"
                size={isMobile ? "medium" : "large"}
              >
                {t("register")}
              </Button>
              <Button
                component={RouterLink}
                to="/register"
                variant="text"
                size={isMobile ? "medium" : "large"}
              >
                {t("open_your_demo_account")}
              </Button>
            </Stack>
          </Grid>
          {!isMobile && (
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={BannerImage} alt="Ebinex: Sem limitações. Sem bloqueios. Payout fixo de 90% por operação." width={600} />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default HomeHeroSection;
